// extracted by mini-css-extract-plugin
export default {"main-container":"CreatedLists_main-container__0FGKb"};